import React, { useState } from "react";
import { getDisplayProfessionalName } from "../../../../../utilities/professionalUtils";
import {
  formatDate,
  formatTime,
  getIsMHCName,
  insertLineBreaks,
} from "../../../../../utilities/utils";
import Loader from "../../../../commons/Loader";
import Pagination from "../../../pagination";
import RefundModal from "../../../../modal/RefundModal";
import SkeletonTable from "../../../../commons/Skeleton/SkeletonTable";

const getStatusClasses = (status) => {
  switch (status) {
    case "Paid":
    case "paid":
      return "bg-[#16CA7C] text-white";
    case "Delinquent":
    case "delinquent":
      return "bg-[#EF2121] text-white";
    case "Past Due":
    case "past due":
      return "bg-[#D85B34] text-white";
    case "Credited":
    case "credited":
      return "bg-[#FFD912] text-customGray";
    case "Partial Refund":
    case "partial refund":
      return "bg-[#D834A0] text-white";
    case "Full Refund":
    case "full refund":
      return "bg-[#7D34D8] text-white";
    default:
      return "bg-customGray text-white";
  }
};

const AdminInvoiceTable = ({ invoices, getUpdateData }) => {
  const [showMenu, setShowMenu] = useState(null);
  const [isShowRefundModal , setIsShowRefundModal]=useState({
    isShow : false,
    inVoiceId : null
  })
  const refundLeadPlan = (invoiceId,type)=>{
      console.log(invoiceId , type)
  }

  const handleMenuItems = (userId, flag) => {
    if (!flag) {
      setShowMenu(userId.id);
    } else {
      setShowMenu(null);
    }
  };

  const { data, meta } = invoices ?? {};
  const { current_page, last_page, per_page } = meta ?? {};

  return (
    <>
      {!invoices ? (
        <SkeletonTable col={8} rows={8} />
      ) : (
        <div className="px-4 sm:px-6 lg:px-8 hidden md:block">
          <div className="mt-8 flow-root">
            <div className="table-scroller -mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 bg-white border border-[#EBEFF3] rounded-md p-5">
              <div className="inline-block min-w-full py-2 align-middle">
                <div className="relative">
                  <table className="min-w-full table-fixed divide-y divide-gray-300">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Tenant
                        </th>
                        <th
                          scope="col"
                          className="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-bold text-[#485868]"
                        >
                          Amount
                        </th>
                        <th
                          scope="col"
                          className="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-bold text-[#485868]"
                        >
                          Profession
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          # of Credits
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Status
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Created Date
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          View
                        </th>
                        {/* <th
                          scope="col"
                          className="relative py-3.5 pl-3 pr-4 sm:pr-0"
                        >
                          <span className="sr-only"></span>
                        </th> */}
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {data &&
                        data?.map((invoice, index) => (
                          <tr key={index}>
                            <td className="whitespace-nowrap py-4 pr-3 text-sm font-normal text-customGray">
                              {invoice?.user?.first_name}{" "}
                              {invoice?.user?.last_name}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              ${invoice.amount}
                            </td>
                            <td
                              className="whitespace-nowrap py-4 pr-3 text-sm font-normal text-customGray"
                              dangerouslySetInnerHTML={{
                                __html: insertLineBreaks(
                                  invoice?.user?.professions[0].name ==
                                    "Mental Health Counselor"
                                    ? getIsMHCName(invoice?.user?.professions[0])
                                    : invoice?.user?.professions
                                        ?.map((profession) => profession.name)
                                        .join(", "),
                                  40
                                ),
                              }}
                            ></td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              {invoice?.user?.credits}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              <span
                                className={`inline-flex items-center capitalize rounded-md px-[10px] py-1 text-xs font-bold leading-[160%] ${getStatusClasses(
                                  invoice?.status
                                )}`}
                              >
                                {invoice?.status}
                              </span>
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              {formatDate(invoice?.created_at)} &#8226;{" "}
                              {formatTime(invoice?.created_at)}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              <span className="text-primary font-bold capitalize cursor-pointer">
                                {invoice?.view ?? "--"}
                              </span>
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              <button
                                className="bg-primary text-white font-bold capitalize px-4 py-2 rounded-md hover:bg-primary-dark transition"
                                onClick={() => setIsShowRefundModal({
                                  isShow:true,
                                  inVoiceId: invoice?.number
                                })} 
                              >
                                Refund
                              </button>
                            </td>
                            {/* <td>
                              <GlobalTableDropDown
                                data={invoice}
                                showMenu={showMenu === invoice.id}
                                callBack={handleMenuItems}
                                isLastIndex={index == invoiceTable.length - 2}
                                menuItems={tableMenuItems}
                              />
                            </td> */}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  {data?.length < 1 && (
                    <h4 className="flex items-center justify-center mt-5 text-lg text-primary py-6 font-bold">
                      No Record Found.
                    </h4>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="block md:hidden">
        <div>
          <ul>
            {data &&
              data.slice(0, 3).map((invoice, index) => (
                <li className="border border-solid border-[#EBEFF3] rounded-md p-5 mb-[14px] flex justify-between bg-[#ffffff]">
                  <ul key={"invoice"+index}>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Tenant
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {invoice?.user?.first_name} {invoice?.user?.last_name}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Amount
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        ${invoice?.amount}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Profession
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {invoice?.user?.professions[0].name ==
                                    "Mental Health Counselor" ? getIsMHCName(invoice?.user?.professions[0]) : invoice?.user?.professions
                          .map((profession) => getIsMHCName(profession))
                          .join(", ")}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        # of Credits
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {invoice?.user?.credits}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Status
                      </h6>
                      <span
                        className={`inline-flex items-center capitalize rounded-md px-[10px] py-1 text-xs font-bold leading-[160%] ${getStatusClasses(
                          invoice?.status
                        )}`}
                      >
                        {invoice?.status}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Created Date
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {formatDate(invoice?.created_at)} &#8226;{" "}
                        {formatTime(invoice?.created_at)}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        View
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {invoice?.view ?? "--"}
                      </span>
                    </li>
                  </ul>
                  {/* <div>
                    <GlobalTableDropDown
                      data={invoice}
                      showMenu={showMenu === invoice.id}
                      callBack={handleMenuItems}
                      isLastIndex={index == invoiceTable.length - 2}
                      menuItems={tableMenuItems}
                    />
                  </div> */}
                </li>
              ))}
          </ul>
          {data?.length < 1 && (
            <h4 className="flex items-center justify-center mt-5 text-lg text-primary py-6 font-bold">
              No Record Found.
            </h4>
          )}
        </div>
      </div>
      {data?.length > 0 && getUpdateData && (
        <Pagination
          currentPage={current_page}
          totalPages={last_page}
          nextPage={getUpdateData}
          previousPage={getUpdateData}
          directIntoPage={getUpdateData}
          perPageItem={per_page}
          showNumberOfPages={3}
          meta={meta}
        />
      )}
      <RefundModal
        isOpen={isShowRefundModal.isShow}
        inVoiceId={isShowRefundModal.inVoiceId}
        handleClose={()=>setIsShowRefundModal({
          isShow:false,
          inVoiceId:null
        })}
        handleConfirm={(invoiceId , type)=>refundLeadPlan(invoiceId , type)}
        deleteLoader={false}
      />
    </>
  );
};

export default AdminInvoiceTable;
